export type GlobalAiChartPreviewPhase =
  | 'idle'
  | 'mounting'
  | 'applying_filters'
  | 'filters_ready'
  | 'fetching'
  | 'success'
  | 'error';

export type GlobalAiChartPreviewDataBranch = 'snowflake' | 'multi' | 'main';

export type GlobalAiChartPreviewRuntimeSnapshot = {
  phase: GlobalAiChartPreviewPhase;
  filterApplyError?: string;
  /** Short line for blocked / in-flight data layer (metric, branch, taxonomy, urql status). */
  providerDiagnostics?: string;
  dataProviderBranch?: GlobalAiChartPreviewDataBranch;
  lastDataProviderStatus?: string;
  timeline?: GlobalAiChartPreviewTimelineEvent[];
};

export type GlobalAiChartPreviewTimelineEvent = {
  atMs: number;
  event: string;
};

export type GlobalAiPipelineTimelineEvent = {
  atMs: number;
  event: string;
};

export function createIdleChartPreviewRuntime(): GlobalAiChartPreviewRuntimeSnapshot {
  return { phase: 'idle' };
}
